import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { get, isFunction } from '@elliemae/ds-utilities/utils';
import { appendCellFormatter } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import getRendererComponent from './getRendererComponent.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-basic/form/Checkbox';
import '@elliemae/ds-basic/form/ComboBox';
import '@elliemae/ds-basic/form/Radio';
import '@elliemae/ds-basic/form/TextBox';
import '@elliemae/ds-basic/form/Toggle';
import '@elliemae/ds-dropdownmenu';
import '../../index-4a6329dc.js';
import '../../components/renderers/defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import '../../blockNames.js';
import '../../components/renderers/renderRowsLoader.js';
import '../../components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var getRenderer = function getRenderer(renderer, grid, column) {
  return function (value, metaData) {
    var _grid$getInstance = grid.getInstance(),
        _grid$getInstance$pro = _grid$getInstance.props,
        customHandlers = _grid$getInstance$pro.customHandlers,
        parentRowData = _grid$getInstance$pro.parentRowData;

    if (column && column.formatExpandable && value && value.props && value.props.children && value.props.children.length === 2) {
      return [value.props.children[0], renderer({
        value: value.props.children[1],
        // apply custom render only to the original value not the arrow
        metaData: _objectSpread(_objectSpread({}, metaData), {}, {
          parentRowData: parentRowData
        }),
        customHandlers: customHandlers
      })];
    }

    return renderer({
      value: value,
      metaData: _objectSpread(_objectSpread({}, metaData), {}, {
        parentRowData: parentRowData
      }),
      customHandlers: customHandlers
    });
  };
};

var addCustomRendererToCell = function addCustomRendererToCell(grid) {
  return function (column) {
    var _column = column,
        customRenderer = _column.customRenderer;
    var customHeaderRenderer = get(column, ['header', 'customRenderer']);
    if (!customRenderer && !customHeaderRenderer) return column;

    if (isFunction(customHeaderRenderer)) {
      column.header.formatters.push(getRenderer(customHeaderRenderer, grid));
    }

    if (isFunction(customRenderer)) {
      column = appendCellFormatter(getRenderer(customRenderer, grid, column), column);
    } else {
      if (!customRenderer) return column;
      column.cell.formatters.push(function (value, columnData) {
        return getRendererComponent(grid, customRenderer, columnData);
      });
    }

    return column;
  };
};

export default addCustomRendererToCell;
export { getRenderer };
//# sourceMappingURL=addCustomRendererToCell.js.map
